<!--
  The shortcut list, rendered from the same table the handler matches against
  (`lib/keymap.ts`). One source, so the help and the behaviour cannot drift.
-->
<script lang="ts">
  import { bindingsByGroup } from '../lib/keymap';

  interface Props {
    open: boolean;
    onclose: () => void;
  }

  const { open, onclose }: Props = $props();
  const groups = bindingsByGroup();
</script>

{#if open}
  <div
    class="scrim"
    role="button"
    tabindex="-1"
    aria-label="Close shortcuts"
    onclick={onclose}
    onkeydown={(event) => event.key === 'Escape' && onclose()}
  ></div>
  <div class="sheet panel" role="dialog" aria-label="Keyboard shortcuts">
    <div class="row">
      <h2>Keyboard shortcuts</h2>
      <span class="spacer"></span>
      <button class="subtle" onclick={onclose}>Close</button>
    </div>
    <p class="small muted">
      The shortcuts are the workflow. Draw a box, the current expected letter is assigned, the
      cursor advances — there is no typing in the loop.
    </p>
    <div class="groups">
      {#each groups as [group, bindings] (group)}
        <section>
          <h3>{group}</h3>
          <ul>
            {#each bindings as binding (binding.action + binding.display)}
              <li>
                <kbd>{binding.display}</kbd>
                <span class="small">{binding.label}</span>
              </li>
            {/each}
          </ul>
        </section>
      {/each}
    </div>
  </div>
{/if}

<style>
  .scrim {
    position: fixed;
    inset: 0;
    background: rgba(6, 8, 11, 0.6);
    z-index: 40;
    border: 0;
  }

  .sheet {
    position: fixed;
    top: 6vh;
    left: 50%;
    transform: translateX(-50%);
    width: min(860px, 92vw);
    max-height: 84vh;
    overflow: auto;
    z-index: 41;
  }

  .groups {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 14px;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  li {
    display: grid;
    grid-template-columns: 96px 1fr;
    gap: 8px;
    align-items: baseline;
  }
</style>
